// Permite habilitar o no la opción de Pago a Cuenta
export const ENABLE_PAGO_A_CUENTA = true;